export default "__VITE_ASSET__BxlN4Iu2__"